// How often every signal view re-reads the server.
//
// One constant because the three views show the SAME numbers, and they used to disagree about how
// stale those numbers were allowed to be: My Signals refreshed every 30s, the detail page every
// 60s, and the marketplace never — it loaded once and sat there until the page was reloaded. A
// signal's card could sit a day behind its own detail page.
export const SIGNAL_REFRESH_MS = 30000;

export default SIGNAL_REFRESH_MS;
